<template>
  <div>
    <b-card header-tag="header" class="m-2 text-left">
      <template v-slot:header>
        <h6 class="mb-0">Details</h6>
      </template>
      <b-card-text>
        <strong>Date:</strong>
        {{age(searchData.created_at)}}
      </b-card-text>
      <!-- <b-card-text>
        <strong>Detected Language:</strong>
        {{searchData.search_results ? JSON.parse(searchData.search_results).detectedSearchTextLanguage : "english"}}
      </b-card-text> -->
      <b-card-text>
        <strong>Searched By:</strong>
        {{searchData.control_group_search.ibf_member && searchData.control_group_search.ibf_member.name || ''}}
      </b-card-text>

      <b-card-text>
        <strong>Control Group</strong>
        {{searchData.control_group_search.control_group.title}}
      </b-card-text>
      <b-card-text>
        <strong>PRI</strong>
        {{searchData.control_group_search.control_group.client_pri_versions.title}}
      </b-card-text>
      
      <b-card-text>
        <strong>Third Party</strong>
        {{searchData.third_party.comp_name_eng || ''}}
      </b-card-text>
      
      
    </b-card>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/es";
export default {
  name: "DetailsComponent",
  data() {
    return {};
  },
  methods: {
    age(value) {
      moment.locale("en");

      return moment.utc(value).fromNow();
    }
  },
  props: {
    searchData: Object
  }
};
</script>